
import router from '@/router';
import store from '@/store';

export default {
  props: {
    propMode: {
      type: String,
      default: '',
    },
    inModal: Boolean,
  },

  data(): Record<string, unknown> {
    return {
      router,
      userRole: store.state.userRole,
    };
  },

  computed: {
    mode(): string {
      return this.propMode || localStorage.getItem('activeMode');
    },

    filter(): string {
      if (this.mode === 'projects') return store.state.assessmentsFilter.projects;
      if (this.mode === 'interviews') return store.state.assessmentsFilter.interviews;
      if (this.mode === 'reports') return store.state.assessmentsFilter.reports;
      return '';
    },

    eventsNumber(): number {
      if (this.mode === 'projects') return store.state.eventsNumber.projects.overall;
      if (this.mode === 'interviews') return store.state.eventsNumber.interviews.overall;
      if (this.mode === 'reports') return store.state.eventsNumber.reports.overall;
      return 0;
    },

    requestsNumber(): number {
      return store.state.eventsNumber.projects.requests;
    },

    ongoingNumber(): number {
      return store.state.eventsNumber.projects.ongoing;
    },

    todoInterviewsNumber(): number {
      return store.state.eventsNumber.interviews.todoInterviews;
    },

    ongoingInterviewsNumber(): number {
      return store.state.eventsNumber.interviews.ongoingInterviews;
    },

    todoNumber(): number {
      return store.state.eventsNumber.reports.todo;
    },

    draftsNumber(): number {
      return store.state.eventsNumber.reports.drafts;
    },

    sentNumber(): number {
      return store.state.eventsNumber.reports.sent;
    },

    fetchingAssessments(): boolean {
      return store.state.interviewsRequestPending;
    },

    fetchingProjects(): boolean {
      return store.state.projectsRequestPending;
    },

    fetchingReports(): boolean {
      return store.state.reportsRequestPending;
    },
  },

  methods: {
    applyAssessmentsFilter(filter: string, mode: string): void {
      const filterNotChanged = filter === this.filter && mode === this.mode;
      const requestPendingForThisMode = this.isRequestPendingForThisMode();
      const preventFromApplyingFilter = filterNotChanged || requestPendingForThisMode;

      if (preventFromApplyingFilter) return;

      store.commit('applyAssessmentsFilter', { filter, mode });
      if (store.state.device === 'mobile' && this.$route.path !== '/events-list') {
        router.push({ path: '/events-list', query: { mode: this.mode } });
      }
    },

    isRequestPendingForThisMode(): boolean {
      if (this.propMode === 'projects' && this.fetchingProjects) return true;
      if (this.propMode === 'interviews' && this.fetchingAssessments) return true;
      if (this.propMode === 'reports' && this.fetchingReports) return true;

      return false;
    },
  },
};
